import classNames from 'classnames';
import React, { ReactElement } from 'react';

import { useIsRendered } from '../../shared/hooks/useIsRendered';

import { SKELETON_BOX_SIZE } from './SKELETON_BOX_SIZE';
import styles from './SkeletonBox.module.css';
import { displayName } from './SkeletonBox.qa';
import { SkeletonBoxPresenter } from './SkeletonBoxPresenter/SkeletonBoxPresenter';

export interface ISkeletonBoxProps {
    'data-testid'?: string;
    className?: string;
    size?: SKELETON_BOX_SIZE;
}

const sizes: { [key: string]: string } = {
    'Size1': 'h-1',
    'Size2': 'h-2',
    'Size3': 'h-3',
    'Size4': 'h-4',
    'Size5': 'h-5',
    'Size6': 'h-6',
    'Size7': 'h-7',
    'Size8': 'h-8',
};

export function OzSkeletonBox (props: ISkeletonBoxProps): ReactElement {
    const {
        'data-testid': dataTestId,
        className = '',
        size,
    }: ISkeletonBoxProps = props;

    const [isRendered, box, onBoxRender] = useIsRendered<HTMLDivElement>();

    const presenter: SkeletonBoxPresenter = new SkeletonBoxPresenter({
        box: box,
    });

    const style: { [key: string]: string } = {};

    if (isRendered) {
        style.width = `${presenter.getBoxWidth()}px`;
        style.left = `${presenter.getBoxLeft()}px`;
    }

    const containerClassNames = classNames({
        'bg-black-10 mb-1 overflow-hidden relative': true,
        [className + '']: !!className,
        [sizes[size + ''] + '']: !!size,
    });

    return (
        <div
            data-testid={dataTestId}
            className={containerClassNames}
        >
            <div ref={onBoxRender} style={style} className={`absolute ${styles.SkeletonBox}`} />
        </div>
    );
}

OzSkeletonBox.displayName = displayName;
